import { find } from 'lodash';
export const getElementSubscription = (state, elementId) => {
    return find(state.subscriptions.resources, (subscription) => subscription.targetId === elementId);
};
